import { ClaimAndTrademarkApproval, Trademark, TrademarkInstance } from '@prisma/client';

export const USTPO_TEXT = 'This trademark is registered with the USPTO';

export const symbolMapping: Record<NonNullable<TrademarkInstance['suggestedMark']>, string> = {
  REGISTERED: '®',
  SERVICE_MARK: '℠',
  TRADEMARK: '™',
};

export const getIsApproved = (approval?: Trademark['approval']) =>
  (
    [
      ClaimAndTrademarkApproval.LIMITED_APPROVAL,
      ClaimAndTrademarkApproval.STANDING_APPROVAL,
    ] as ClaimAndTrademarkApproval[]
  ).includes(approval!);

export const getTmTexts = (
  tmInstance: Pick<
    TrademarkInstance,
    'suggestedMarkRecord' | 'suggestedMarkExplanation' | 'suggestedMark'
  >,
  proprietary: boolean,
  approval: Trademark['approval'],
) => {
  const texts: string[] = [];

  if (getIsApproved(approval)) {
    texts.push(`This trademark has been previously approved.`);
  } else if (proprietary) {
    texts.push('Make sure to follow trademark guidelines.');
  } else {
    // if (!tmInstance.matches.length) {
    //   texts.push(
    //     `This is the first time the ${tmInstance.text} trademark is used. Are there permissions to use this name?`,
    //   );
    // }

    if (tmInstance.suggestedMarkRecord) {
      texts.push(
        `${USTPO_TEXT} - #${(tmInstance.suggestedMarkRecord as any).registration_number}. Are there trademark guidelines from the owner that apply?`,
      );
    }

    if (tmInstance.suggestedMarkExplanation) {
      texts.push(tmInstance.suggestedMarkExplanation);
    }

    if (tmInstance.suggestedMark) {
      texts.push(
        `If appropriate, use the ${symbolMapping[tmInstance.suggestedMark]} symbol after the text.`,
      );
    }
  }
  return texts;
};
